import React, {Component} from 'react';
import Template from '../interfaz/Template';
import * as etiquetas from '../../ApplicationResources';
import AuthenticatedComponent from '../AuthenticatedComponent';
import {Link} from "react-router-dom"
import axios from 'axios';
import {connect} from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectProceso, selectEstado, selectDistrito, selectRutaPublicador } from '../../redux/menu/menu-selectors';
import { selectCurrentUser, selectCurrentUserRol } from '../../redux/user/user-selectors';
import '../../css/options_menu.css';
import { Col, Row } from 'antd';
import Menu from '../interfaz/Elements/Menu';
import { updateRutaPublicador } from '../../redux/menu/menu-actions';
import { obtenerRutaPublicador } from '../../redux/menu/menu-utils';


class MenuJDE extends Component {
  constructor(props){
    super(props);
  }

  funcionListo = () =>{
  }

  componentDidUpdate(prevProps){
    // Comparamos si el usuario ha seleccionado otro estado, proceso, distrito para volver a cargar la gráfica y actividades
    if(this.props.proceso !== prevProps.proceso
      || this.props.estado !== prevProps.estado
      || this.props.distrito !== prevProps.distrito){
        this.publicador();

        return;
      }
  }

  // Función que permite consultar el publicador
  publicador = async () => {
    // Estado y proceso seleccionado por el usuario, ruta del publicador asociado al proceso seleccionado
    // user=>datos del usuario logueado
    const { estado, proceso, rutaPublicador, user } = this.props;

    // Datos del proceso seleccionado por el usuario
    const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
    const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;

    // Datos de la entidad seleccionada por el usuario
    const idEstado = estado ? estado.idEstado : 0;

    // Si no hay ruta de publicador en el proceso seleccionado por el usuario
    if(rutaPublicador === undefined && idProcesoElectoral > 0 && idDetalleProceso > 0) {
      // Consultamos la ruta del publicador
      var rutaP = await obtenerRutaPublicador(
        idProcesoElectoral, 
        idDetalleProceso, 
        user.idEstado, 
        user.idDistrito, 
        user.rolUsuario, 
        user.username,
        proceso.descripcionDetalleLarga
      );

      // Actualizamos la ruta con el dispatchToProps
      this.props.updateRutaPublicador(
        idEstado,
        idDetalleProceso,
        rutaP
      );
    }
  }

  render() {
      return (
      <AuthenticatedComponent externo={false} listo={this.funcionListo}>
        <Template contenido={
          <>
            <Menu />
          </>
        }
        guia={false}
        />
      </AuthenticatedComponent>);
  }
};

const mapStateToProps = createStructuredSelector({
  estado: selectEstado,
  proceso: selectProceso,
  distrito: selectDistrito,
  user: selectCurrentUser,
  rolUsuario: selectCurrentUserRol,
  rutaPublicador : selectRutaPublicador
});

const mapDispatchToProps = dispatch => ({
  updateRutaPublicador: (idEstado, idDetalle, rutaPublicador) => dispatch(updateRutaPublicador(idEstado, idDetalle, rutaPublicador))
});

export default connect(mapStateToProps, mapDispatchToProps)(MenuJDE);
